(function () {
  'use strict';

  var selector = '.wb-feed';

  function initFeed(section) {
    if (!section || section.dataset.wbFeedReady === 'true') return;

    section.dataset.wbFeedReady = 'true';

    var track = section.querySelector('.wb-feed__track');
    var btnPrev = section.querySelector('.wb-feed__arrow--prev');
    var btnNext = section.querySelector('.wb-feed__arrow--next');
    var progressBar = section.querySelector('.wb-feed__progress-bar');

    if (!track) return;

    var rafId = null;

    function getStep() {
      var firstItem = track.querySelector('.wb-feed__item');
      if (!firstItem) return track.clientWidth * 0.8;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || 0);

      return firstItem.getBoundingClientRect().width + gap;
    }

    function updateUI() {
      var maxScroll = track.scrollWidth - track.clientWidth;
      var scrollLeft = track.scrollLeft;

      if (btnPrev) {
        btnPrev.disabled = scrollLeft <= 4;
      }

      if (btnNext) {
        btnNext.disabled = maxScroll <= 4 || scrollLeft >= maxScroll - 4;
      }

      if (progressBar) {
        progressBar.style.width = maxScroll > 0 ? (scrollLeft / maxScroll) * 100 + '%' : '0%';
      }
    }

    function requestUpdate() {
      if (rafId) cancelAnimationFrame(rafId);

      rafId = requestAnimationFrame(function () {
        updateUI();
        rafId = null;
      });
    }

    track.addEventListener('scroll', requestUpdate, { passive: true });

    if (btnPrev) {
      btnPrev.addEventListener('click', function (event) {
        event.preventDefault();
        track.scrollBy({ left: -getStep(), behavior: 'smooth' });
      });
    }

    if (btnNext) {
      btnNext.addEventListener('click', function (event) {
        event.preventDefault();
        track.scrollBy({ left: getStep(), behavior: 'smooth' });
      });
    }

    window.addEventListener('resize', requestUpdate, { passive: true });

    updateUI();

    section._wbFeedUpdate = requestUpdate;
  }

  function init(root) {
    var scope = root || document;
    scope.querySelectorAll(selector).forEach(initFeed);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () {
      init(document);
    });
  } else {
    init(document);
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();